var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/utils/date.utils.ts
function getTimezoneOffsetMs(timezone, refDate = /* @__PURE__ */ new Date()) {
  const utcStr = refDate.toLocaleString("en-US", {
    timeZone: "UTC"
  });
  const tzStr = refDate.toLocaleString("en-US", {
    timeZone: timezone
  });
  return new Date(utcStr).getTime() - new Date(tzStr).getTime();
}
__name(getTimezoneOffsetMs, "getTimezoneOffsetMs");
function localTimeToUTC(timeStr, baseDate, timezone) {
  const [hours, minutes] = timeStr.split(":").map(Number);
  const result = new Date(baseDate);
  result.setUTCHours(hours, minutes, 0, 0);
  const offsetMs = getTimezoneOffsetMs(timezone, result);
  return new Date(result.getTime() + offsetMs);
}
__name(localTimeToUTC, "localTimeToUTC");
function todayLocal(timezone) {
  return (/* @__PURE__ */ new Date()).toLocaleDateString("en-CA", {
    timeZone: timezone
  });
}
__name(todayLocal, "todayLocal");
function formatDateISO(date, timezone) {
  return new Date(date).toLocaleDateString("en-CA", {
    timeZone: timezone
  });
}
__name(formatDateISO, "formatDateISO");
var DATE_ONLY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;
function isValidDateInput(date) {
  if (date === null || date === void 0 || date === "") {
    return false;
  }
  return !Number.isNaN(new Date(date).getTime());
}
__name(isValidDateInput, "isValidDateInput");
function dateParts(date, timezone, withTime) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    ...withTime ? {
      hour: "2-digit",
      minute: "2-digit",
      hourCycle: "h23"
    } : {},
    timeZone: timezone
  }).formatToParts(new Date(date));
  const get = /* @__PURE__ */ __name((type) => parts.find((p) => p.type === type)?.value ?? "", "get");
  return {
    y: get("year"),
    m: get("month"),
    d: get("day"),
    hh: get("hour"),
    mm: get("minute")
  };
}
__name(dateParts, "dateParts");
function formatDate(date, _locale, timezone) {
  if (typeof date === "string") {
    const m2 = DATE_ONLY_RE.exec(date);
    if (m2) {
      return `${m2[1]}.${m2[2]}.${m2[3]}.`;
    }
  }
  if (!isValidDateInput(date)) {
    return String(date ?? "");
  }
  const { y, m, d } = dateParts(date, timezone, false);
  return `${y}.${m}.${d}.`;
}
__name(formatDate, "formatDate");
function formatDateTime(date, _locale, timezone) {
  if (!isValidDateInput(date)) {
    return String(date ?? "");
  }
  const { y, m, d, hh, mm } = dateParts(date, timezone, true);
  return `${y}.${m}.${d}. ${hh}:${mm}`;
}
__name(formatDateTime, "formatDateTime");
function formatDateTimeLong(date, locale, timezone) {
  return formatDateTime(date, locale, timezone);
}
__name(formatDateTimeLong, "formatDateTimeLong");
function formatTime(date, locale, timezone) {
  return new Date(date).toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: timezone
  });
}
__name(formatTime, "formatTime");
function formatDateCustom(date, locale, timezone, options) {
  return new Date(date).toLocaleDateString(locale, {
    ...options,
    timeZone: timezone
  });
}
__name(formatDateCustom, "formatDateCustom");
function formatHoursHM(hours) {
  const n = Number(hours);
  if (!Number.isFinite(n)) {
    return "0:00";
  }
  const sign = n < 0 ? "-" : "";
  const totalMinutes = Math.round(Math.abs(n) * 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return `${sign}${h}:${String(m).padStart(2, "0")}`;
}
__name(formatHoursHM, "formatHoursHM");
function isNextDayCheckout(checkIn, checkOut) {
  if (!(checkIn && checkOut)) {
    return false;
  }
  return checkOut <= checkIn;
}
__name(isNextDayCheckout, "isNextDayCheckout");
function parseHoursHM(value) {
  const s = String(value ?? "").trim();
  if (!s) {
    return 0;
  }
  const hm = s.match(/^(-?)(\d{1,3}):([0-5]?\d)$/);
  if (hm) {
    const sign = hm[1] === "-" ? -1 : 1;
    return sign * (Number(hm[2]) + Number(hm[3]) / 60);
  }
  const n = Number(s);
  return Number.isFinite(n) ? n : 0;
}
__name(parseHoursHM, "parseHoursHM");
export {
  formatDate,
  formatDateCustom,
  formatDateISO,
  formatDateTime,
  formatDateTimeLong,
  formatHoursHM,
  formatTime,
  isNextDayCheckout,
  localTimeToUTC,
  parseHoursHM,
  todayLocal
};
//# sourceMappingURL=date.mjs.map